/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";

// Import CKEditor here (both required).
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import { assetImages } from "constants";

import {
  getData,
  uploadSingleFile,
  uploadMultipleFile,
  postData,
  putData,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";
import ProfileHeader from "../Header/ProfileHeader";

const MyAccountBody = ({}) => {
  /*---- CKEditor classic editor configuration start ----- */
  const editorConfig = {
    toolbar: ["bold", "italic", "link", "bulletedList", "numberedList"],
    ckfinder: {
      // Upload the images to the server using the CKFinder QuickUpload command.
      //   uploadUrl: url.URL_TEXT_EDITOR_IMAGE_UPLOAD_2,
    },
    placeholder: "Type details here...",
  };
  /*---- CKEditor classic editor configuration end ----- */

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const loadingCircle = [1, 2, 3, 4, 5, 6];
  const params = useParams();
  const history = useHistory();

  const profileImageRef = useRef(null);
  const uploadFileInputRef = useRef(null);

  const [skillList, setSkillList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [profilePic, setProfilePic] = useState("");
  const [profilePicId, setProfilePicId] = useState(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);

  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [position, setPosition] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [bioDetails, setBioDetails] = useState("");
  const [address, setAddress] = useState("");
  const [rank, setRank] = useState(1);
  const [website, setWebsite] = useState("");
  const [rate, setRate] = useState("");
  const [skillValue, setSkillValue] = useState(null);
  const [skills, setSkills] = useState([]);
  const [interestValue, setInterestValue] = useState(null);
  const [interest, setInterest] = useState([]);
  const [languageValue, setLanguageValue] = useState(null);
  const [language, setLanguage] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFileIds, setUploadedFileIds] = useState([]);
  const [ecosystemValue, setEcosystemValue] = useState(null);
  const [referCode, setreferCode] = useState("");
  const [mentorName, setmentorName] = useState("");
  const [mentorProfileId, setmentorProfileId] = useState("");

  const [isSaving, setIsSaving] = useState(false);

  //function for get all modules
  const getAllEcosystems = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_ECOSYSTEM + `?token=${token}`;

      // console.log(requestUrl);

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setEcosystemList(
          response.data.map((item) => ({
            label: item.name,
            value: item._id,
          }))
        );
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all categories
  const getAllCategories = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CATEGORIES +
        `?token=${token}&slug=skills`;

      const response = await getData(requestUrl);

      if (response.status) {
        setSkillList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  /* function to fetch location from zip code */
  const getLocationFromZip = async (e) => {
    e.preventDefault();
    if (zipcode !== "") {
      try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${zipcode}&region=es&key=AIzaSyDt4dbtdHCHLj8grTzTVxpztvqUGDkvkaI`;

        const response = await getData(url);

        if (response.status === "OK") {
          const results = response.results;
          if (results.length > 0) {
            results[0]?.address_components.map((item) => {
              // console.log(`item`, JSON.stringify(item));
              if (item.types[0] === "country") {
                setcountry(item?.long_name);
              }
              if (item.types[0] === "locality") {
                setcityName(item?.long_name);
              }
              if (item.types[0] === "administrative_area_level_1") {
                setstateName(item?.long_name);
              }
            });
            // setMapCoordinate(
            //   `https://maps.google.com/maps?q=${results[0]?.geometry?.location?.lat},${results[0]?.geometry?.location?.lng}`
            // );
          } else {
            console.log("No results found.");
          }
        } else {
          console.log("Request failed with status:", response.status);
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    }
  };

  //function for open cover image file input
  const profileImageOpen = () => {
    profileImageRef.current.click();
  };

  //function for upload cover image
  const profileImageUploadHandler = async (e) => {
    const file = e.target.files[0];
    setIsImageUploading(true);
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadSingleFile(requestUrl, file);

      console.log("upload response-------->", response);

      if (response.status) {
        setIsImageUploading(false);
        setProfilePic(url.SERVER_URL + response.data.path);
        setProfilePicId(response.data._id);
        resetProfileImageFile();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // function for clear file value
  const resetProfileImageFile = () => {
    const file = document.getElementById("uploadprofileimage");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //function for select skills
  const skillSelectionHandler = (val) => {
    setSkillValue(val);
    const valArr = val.map((item) => item.value);
    setSkills(valArr);
  };

  //function for select interest
  const interestSelectionHandler = (val) => {
    setInterestValue(val);
    const valArr = val.map((item) => item.value);
    setInterest(valArr);
  };

  //function for select language
  const languageSelectionHandler = (val) => {
    setLanguageValue(val);
    setLanguage(val.value);
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    setRoleValue(val);
    setRoleId(val.value);
  };

  //function for open image imput
  const openUploadFileInput = () => {
    uploadFileInputRef.current.click();
  };

  //function for image upload
  const docFileUploadHandler = async (e) => {
    try {
      setIsFileUploading(true);

      const docUploadedFiles = e.target.files;

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, docUploadedFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        console.log(uploadedFileValues);

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedFiles.length == 0) {
          setUploadedFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedFiles.concat(uploadedFileValues);
          setUploadedFiles(fileArr);
        }
        /*----- assign uploaded files with path for display end ------*/

        setIsFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedFileIds.length == 0) {
          setUploadedFileIds(fileIds);
        } else {
          let fileArr = uploadedFileIds.concat(fileIds);
          setUploadedFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      }
      resetDocFileInput();
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    const closedFile = [...uploadedFiles];
    const removedFileId = [...uploadedFileIds];

    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);

    setUploadedFiles(closedFile);
    setUploadedFileIds(removedFileId);

    resetDocFileInput();
  };

  //function for reset video inputs
  const resetDocFileInput = () => {
    const file = document.getElementById("docfileinput");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //function for get user details
  const getExpertDetails = async () => {
    setIsSaving(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${userInfo._id}` +
        `?token=${token}`;

      const response = await getData(requestUrl);
      setIsSaving(false);

      console.log(response);

      if (response.status && response.data) {
        const data = response.data;

        setProfilePic(data.userimage); // Ensure default value if undefined
        setProfilePicId(data.userimageid || null); // Ensure default value if undefined
        setName(data.name || "");
        setSurName(data.surname || "");
        setEmail(data.email || "");
        setTelephone(data.phone || "");
        setPosition(data.position || "");
        setCompanyName(data.company || "");
        setBioDetails(data.about || "");
        setreferCode(data.referralcode || "");
        setWebsite(data.website || "");

        const skillData = data.userskills || [];
        skillSelectionHandler(skillData);
        const interestData = data.userinterests || [];
        interestSelectionHandler(interestData);

        setstateName(data.state || "");
        setcityName(data.city || "");
        setcountry(data.country || "");
        setzipcode(data.zipcode || "");
        setAddress(data.address || "");
        setmentorName(data.mentorname || "");
        setmentorProfileId(data.mentoraccountid || "");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for save/update user
  const saveUserHandler = async () => {
    if (email != "") {
      try {
        let userData = {
          photoimage: profilePicId,
          name,
          surname: surName,
          email,
          position,
          company: companyName,
          phone: telephone,
          address,
          about: bioDetails,
          city: cityName,
          state: stateName,
          country,
          zipcode,
          skills,
          interests: interest,
          website,
        };

        console.log(userData);

        let requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_APP_USER +
          `/${userInfo?._id}` +
          `?token=${token}`;

        const response = await putData(requestUrl, userData);

        console.log(response);

        if (response.status) {
          resetHandler();
          getExpertDetails();
          //     const bootstrapModal = new bootstrap.Modal(
          //       document.getElementById("afterSaveExpertModal")
          //     );
          //     bootstrapModal.show();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  //function for reset
  const resetHandler = () => {
    setProfilePic("");
    setProfilePicId(null);
    setName("");
    setSurName("");
    setEmail("");
    setTelephone("");
    setPosition("");
    setBioDetails("");
    setAddress("");
    setRank(1);
    setWebsite("");
    setRate("");
    setSkillValue(null);
    setSkills([]);
    setInterestValue(null);
    setInterest([]);
    setLanguageValue(null);
    setLanguage("");
    setRoleValue(null);
    setRoleId(null);
    setstateName("");
    setcityName("");
    setcountry("");
    setzipcode("");
    setUploadedFiles([]);
    setUploadedFileIds([]);
    setEcosystemValue(null);
    setreferCode("");
    setmentorName("");
    setmentorProfileId("");
  };

  useEffect(() => {
    if (userInfo) {
      getExpertDetails();
    }
  }, []);

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
    <div className="accont_innr">
      <ProfileHeader
        profileImageOpen={profileImageOpen}
        profileImageUploadHandler={profileImageUploadHandler}
        profilePic={profilePic}
        profileImageRef={profileImageRef}
        name={name}
        surName={surName}
        cityName={cityName}
        stateName={stateName}
        country={country}
        userInfo={userInfo}
        position={position}
        referCode={referCode}
      />

      <div className="account_bxitem bg_white p-4  mb-4">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* ---- name / surname ------ */}
          <div className="form-group mb-3">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                <label htmlFor="name" className="fw-bold mb-2 text-black fs-md">
                  Name*
                </label>
                <input
                  type="text"
                  // id={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control body_bg primary_border"
                  placeholder="Enter Name"
                  value={name}
                  required
                />
              </div>
              <div className="col-lg-6">
                <label
                  htmlFor="surname"
                  className="fw-bold mb-2 text-black fs-md"
                >
                  Surname
                </label>
                <input
                  type="text"
                  // id="surname"
                  className="form-control body_bg primary_border"
                  placeholder="Enter Surname"
                  value={surName}
                  onChange={(e) => setSurName(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          {/* email */}
          <div className="form-group mb-3">
            <label className="fw-bold mb-2 text-black fs-md">Email*</label>
            <input
              type="email"
              className="form-control body_bg primary_border"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* ----- email / telephone / position ------- */}
          <div className="form-group mb-3 mb-sm-4">
            <div className="row">
              <div className="col-lg-4 mb-3 mb-sm-3 mb-lg-0">
                <label
                  htmlFor="telephone"
                  className="fw-bold mb-2 text-black fs-md"
                >
                  Telephone
                </label>
                <input
                  type="tel"
                  id="telephone"
                  className="form-control body_bg primary_border"
                  placeholder="Enter Enter Telephone"
                  value={telephone}
                  onChange={(e) => setTelephone(e.target.value)}
                />
              </div>
              <div className="col-lg-4">
                <label
                  htmlFor="position"
                  className="fw-bold mb-2 text-black fs-md"
                >
                  Position
                </label>
                <input
                  type="text"
                  id="position"
                  className="form-control body_bg primary_border"
                  placeholder="Enter Position"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                />
              </div>
              <div className="col-lg-4">
                <label
                  htmlFor="company"
                  className="fw-bold mb-2 text-black fs-md"
                >
                  Company Name
                </label>
                <input
                  type="text"
                  id="company"
                  className="form-control body_bg primary_border"
                  placeholder="Enter Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="form-group mb-3">
            <div className="row">
              <div className="col-lg-4 mb-3 mb-lg-0">
                <label className="fw-bold mb-2 text-black fs-md">Zipcode</label>
                <div className="d-flex gap-2">
                  <input
                    type="text"
                    className="form-control body_bg primary_border"
                    placeholder="Zipcode"
                    value={zipcode}
                    onChange={(e) => setzipcode(e.target.value)}
                  />
                  <button
                    className="btn primary-btn p-2"
                    onClick={getLocationFromZip}
                  >
                    Fetch Location by zipcode
                  </button>
                </div>
              </div>

              {/* ----- city,state,country section start ------ */}
              <div className="col-lg-8">
                <div className="row">
                  {/* ----- city section start ------ */}
                  <div className="col-lg-4 mb-3 mb-lg-0">
                    <label className="fw-bold mb-2 text-black fs-md">
                      City
                    </label>
                    <input
                      type="text"
                      className="form-control body_bg primary_border"
                      placeholder="City"
                      value={cityName}
                      onChange={(e) => {
                        setcityName(e.target.value);
                      }}
                    />
                  </div>
                  {/* ----- city section end ------ */}

                  {/* ----- state section start ------ */}
                  <div className="col-lg-4 mb-3 mb-lg-0">
                    <label className="fw-bold mb-2 text-black fs-md">
                      State
                    </label>
                    <input
                      type="text"
                      className="form-control body_bg primary_border"
                      placeholder="State"
                      value={stateName}
                      onChange={(e) => {
                        setstateName(e.target.value);
                      }}
                    />
                  </div>
                  {/* ----- state section end ------ */}

                  {/* ----- country section start ------ */}
                  <div className="col-lg-4">
                    <label className="fw-bold mb-2 text-black fs-md">
                      Country
                    </label>
                    <input
                      type="text"
                      className="form-control body_bg primary_border"
                      placeholder="Country"
                      value={country}
                      onChange={(e) => {
                        setcountry(e.target.value);
                      }}
                    />
                  </div>
                  {/* ----- country section end ------ */}
                </div>
              </div>
              {/* ----- city,state,country section end ------ */}
            </div>
          </div>

          <div className="form-group mb-3">
            <label className="fw-bold mb-2 text-black fs-md">Address</label>
            <input
              type="text"
              className="form-control body_bg primary_border"
              placeholder="Enter location"
              value={address}
              onChange={(e) => {
                setAddress(e.target.value);
              }}
            />
          </div>

          {/* about */}
          <div className="form-group mb-3">
            <label className="fw-bold mb-2 text-black fs-md">About</label>
            <CKEditor
              className="form-control body_bg primary_border"
              editor={ClassicEditor}
              config={editorConfig}
              data={bioDetails ? bioDetails : ""}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "200px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
              onChange={(event, editor) => {
                let editorContent = editor.getData();
                setBioDetails(editorContent);
              }}
            />
          </div>

          {/* website */}
          <div className="form-group mb-3">
            <label className="fw-bold mb-2 text-black fs-md">Website</label>
            <input
              type="text"
              value={website}
              onChange={(e) => {
                setWebsite(e.target.value);
              }}
              className="form-control body_bg primary_border"
              placeholder="Enter website"
            />
          </div>

          <div className="form-group mb-3">
            <label className="fw-bold mb-2 text-black fs-md">
              Personal Interest
            </label>
            <Select
              isMulti
              options={skillList}
              placeholder="Select Interest"
              value={interestValue}
              onChange={(val) => {
                interestSelectionHandler(val);
              }}
            />
          </div>

          <div className="form-group mb-3">
            <label className="fw-bold mb-2 text-black fs-md">
              Theatrical Interest
            </label>
            <Select
              isMulti
              options={skillList}
              placeholder="Select Skills"
              value={skillValue}
              onChange={(val) => {
                skillSelectionHandler(val);
              }}
            />
          </div>

          {/* refer code */}
          <div className="form-group mb-3">
            <label className="fw-bold mb-2 text-black fs-md">Refferer</label>
            <Link
              to={
                mentorProfileId == "" ? "#" : `/user/details/${mentorProfileId}`
              }
              className="form-control body_bg primary_border d-flex align-items-center"
            >
              {mentorName}
            </Link>
          </div>

          <div className="form-group d-flex align-items-center justify-content-between">
            <button
              className="btn primary-btn"
              onClick={saveUserHandler}
              disabled={isSaving ? true : false}
              style={{
                cursor: isSaving ? "not-allowed" : "pointer",
              }}
            >
              Save
              {isSaving && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MyAccountBody;
